import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const getAdminToken = () => localStorage.getItem('erbity_admin_token') || '';
export const setAdminToken = (t) => localStorage.setItem('erbity_admin_token', t);
export const clearAdminToken = () => localStorage.removeItem('erbity_admin_token');

export const adminHeaders = () => ({ headers: { 'X-Admin-Token': getAdminToken() } });

// Public
export const createEnquiry = (payload) => api.post('/enquiries', payload).then((r) => r.data);
export const pitchDeckUrl = `${API}/pitch-deck`;
export const listJobs = (industry) => api.get('/jobs', { params: industry ? { industry } : {} }).then((r) => r.data);
export const getJob = (id) => api.get(`/jobs/${id}`).then((r) => r.data);
export const applyToJob = (id, payload) => api.post(`/jobs/${id}/apply`, payload).then((r) => r.data);
export const listCaseStudies = () => api.get('/case-studies').then((r) => r.data);

// Admin
export const verifyAdmin = () => api.post('/admin/verify', {}, adminHeaders()).then((r) => r.data);
export const adminListEnquiries = () => api.get('/admin/enquiries', adminHeaders()).then((r) => r.data);
export const adminListApplications = () => api.get('/admin/applications', adminHeaders()).then((r) => r.data);
export const adminCreateCaseStudy = (b) => api.post('/admin/case-studies', b, adminHeaders()).then((r) => r.data);
export const adminDeleteCaseStudy = (id) => api.delete(`/admin/case-studies/${id}`, adminHeaders()).then((r) => r.data);
export const adminCreateJob = (b) => api.post('/admin/jobs', b, adminHeaders()).then((r) => r.data);
export const adminDeleteJob = (id) => api.delete(`/admin/jobs/${id}`, adminHeaders()).then((r) => r.data);
